import { render, staticRenderFns } from "./EnviarFotoPorQRCodePaciente.vue?vue&type=template&id=2b9af04f&scoped=true"
import script from "./EnviarFotoPorQRCodePaciente.vue?vue&type=script&lang=js"
export * from "./EnviarFotoPorQRCodePaciente.vue?vue&type=script&lang=js"
import style0 from "./EnviarFotoPorQRCodePaciente.vue?vue&type=style&index=0&id=2b9af04f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9af04f",
  null
  
)

export default component.exports